import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Phone from '@vst/beam-icons/icons/Phone';
import { ViasatLogoDefault } from '@vst/beam-icons/logos/viasat';
import { Icon, Logo, Surface, Txt, StandAloneLink } from '@vst/beam';

import { pnApiRun } from '@buy-viasat/utils';
import { selectCidPhoneNumber } from '@buy-viasat/redux/src/app';

import styles from './header.module.scss';

type HeaderProps = {
  // Fallback phone number used when no CID-matched number is available (no CID captured, no
  // matching mapping loaded, or nothing has loaded yet). The CID-resolved number, if present,
  // always takes precedence — see selectCidPhoneNumber.
  phoneNumber: string;
  linkUrl: string;
  linkPrefix: string;
};

export const Header = (props: HeaderProps) => {
  const { phoneNumber: defaultPhoneNumber, linkUrl, linkPrefix } = props;
  const cidPhoneNumber = useSelector(selectCidPhoneNumber);
  const phoneNumber = cidPhoneNumber ?? defaultPhoneNumber;

  useEffect(() => {
    setTimeout(() => {
      pnApiRun();
    });
  }, []);

  const href = `tel:${phoneNumber}`;

  return (
    <Surface variant="primary" responsive className={styles['headerWrapper']}>
      <StandAloneLink href={linkUrl} openInNewLocation data-testid="headerLogoLink">
        <Logo logo={ViasatLogoDefault} display="inline" size={96} alt="Viasat" data-testid="headerLogo" />
      </StandAloneLink>
      <Surface className={styles['contactUsContainer']}>
        <Txt variant="bodyLargeBold" color="subtle" mr="24px" data-testid="contactUs" className={styles['hidden']}>
          {linkPrefix}
        </Txt>
        <Txt component="span" mr="12px">
          <Icon icon={Phone} color="gray_600" data-testid="phoneIconDesktop" />
        </Txt>
        <Txt variant="bodyLargeBold" color="subtle" className={styles['linkContainer']}>
          <StandAloneLink
            href={href}
            linkSize="large"
            variant="primary"
            data-skip-invoca="true"
            data-testid="linkNumberDesktop"
          >
            {phoneNumber}
          </StandAloneLink>
        </Txt>
      </Surface>
    </Surface>
  );
};
